import { combineEpics } from 'redux-observable';
import TagManagerEpics from './tagManager.epic';
import AuthEpics from '../../auth/epics';
import UserManagementEpics from '../../technicians/epics/userManagement.epic';
import ProfileEpics from '../../profile/epics/profile.epic';
import TaskEpics from '../../jobs/epics';
import NotificationEpics from './notification.epic';
import CustomizationEpics from '../../customization/epics';
import InsightsEpics from '../../insights/epics/insights.epic';
import BillingEpics from './billing.epic';
import OrgHierarchyEpics from './orgHierarchy.epic';
import ChatEpics from '../../chat/epics/chat.epic';
import SessionEpics from '../../jobs/epics/sessions.epic';
import InternalSignUpEpics from '../../i-admin/epics/internalSignUp.epic';

// Combine epics to handle side effects. Action hits epic after it was processed by root reducer.
const rootEpic = combineEpics(
  ...AuthEpics,
  ...UserManagementEpics,
  ...ProfileEpics,
  ...TaskEpics,
  ...NotificationEpics,
  ...CustomizationEpics,
  ...InsightsEpics,
  ...BillingEpics,
  ...OrgHierarchyEpics,
  ...TagManagerEpics,
  ...ChatEpics,
  ...SessionEpics,
  ...InternalSignUpEpics,
);

export default rootEpic;
